import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";

const token = localStorage.getItem("token");

export const getAdminProfileData = createAsyncThunk("getAdmin", async () => {
    const response = await axios.get(`${baseUrl}/admins/userdetails/1`, {
        headers: {
            authorization: token
        }
    });

    console.log("profileResponse", response.data);
    return response.data;
});

export const getAdminBankDetails = createAsyncThunk(
    "getUserBankDetails",
    async ({ id, data }) => {
        console.log("slice img", id, data);
        const response = await axios.get(
            `${baseUrl}/profile/finduserbankdetails/1`,
            data
        );
        console.log("User BankDetails Response", response.data);
        return response.data.data;
    }
);

export const setActiveBankAccount = createAsyncThunk(
    "setActiveBankAccount",
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}/admins/setBankAccountPrimary/${id}`
            );
            console.log("User BankD Active", response.data);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const ProfileSlice = createSlice({
    name: "profile",

    initialState: {
        Profile: {},
        BankDetails: [],
        changePassword: "",
        status: "",
        error: ""
    },

    extraReducers(builder) {
        // get admin details
        builder
            .addCase(getAdminProfileData.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getAdminProfileData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Profile = action.payload;
            })
            .addCase(getAdminProfileData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getAdminBankDetails.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getAdminBankDetails.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.BankDetails = action.payload;
            })
            .addCase(getAdminBankDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export default ProfileSlice.reducer;
